import api from './api/api'

export const findSolcitacoesByFiltro = async (filtro) => {
  return api().post('/solicitacaoCredenciado/findByFiltro', filtro)
}

export const findSolcitacoesByEdital = async (idEdital) => {
  return api().get(`/solicitacaoCredenciado/findSolcitacoesByEdital/${idEdital}`)
}

export const findById = async (id) => {
  return api().get(`/solicitacaoCredenciado/findById/${id}`)
}

export const validar = async (dto) => {
  return api().post('solicitacaoCredenciado/validar/', dto)
}
export const validarCredenciado = async (dto) => {
  return api().post('solicitacaoCredenciado/validarCredenciado/', dto)
}

export const solicitacaoCadastradaByCpfAndEdital = async (cpf, editalId) => {
  return api().get(`/publico/solicitacaoCredenciado/solicitacaoCadastradaByCpfAndEdital/${cpf}/${editalId}`)
}

export const findByCurrentUser = async () => {
  return api().get('/solicitacaoCredenciado/findByCurrentUser')
}

export const retificar = async (id, dto) => {
  return api().put(`/solicitacaoCredenciado/retificar/${id}`, dto)
}

export const findSituacaoRetificadoByCurrentUser = async () => {
  return api().get('/solicitacaoCredenciado/findSituacaoRetificadoByCurrentUser')
}

export const exportCSVListagemSolicitacoes = async (idEdital) => {
  return api().post(`/solicitacaoCredenciado/listagem/exportar/${idEdital}`, null, {responseType: 'blob'})
}

export const descredenciarSolicitacao = async (solicitacao) => {
  return api().post(`/solicitacaoCredenciado/descredenciar`, solicitacao)
}
